import { useCartStore } from "@/stores/cart";

const cartTokenCookieName = "b2k_cart_token";

export default function useCartSession() {
  const cartStore = useCartStore();

  const isProcessing = ref(false);

  const cartToken = useCookie(cartTokenCookieName, {
    sameSite: "lax",
    maxAge: 60 * 60 * 24 * 7, // 7 days
  });

  const syncCartItems = async (callback) => {
    if (cartStore.cartItems.length === 0) {
      return;
    }

    try {
      isProcessing.value = true;

      const indexedItems = Object.fromEntries(cartStore.cartItems.map((item, index) => [`test_id[${index}]`, item.id]));
      const indexedQuantities = Object.fromEntries(
        cartStore.cartItems.map((item, index) => [`quantity[${index}]`, item.quantity])
      );
      const params = { ...indexedItems, ...indexedQuantities };

      if (cartToken.value) {
        params.cart_token = cartToken.value;
      }

      const { data: cartResponse } = await useCartDetails(params);
      const response = cartResponse.value?.data;

      if (response) {
        cartToken.value = response.cart_token;
        callback(response);
      }
    } finally {
      isProcessing.value = false;
    }
  };

  const syncCartItemsPrices = (remoteCart) => {
    if (!remoteCart?.test?.length || !cartStore.cartItems.length) {
      return;
    }

    const remoteItemsMap = new Map(remoteCart.test.map((item) => [item.id, item]));

    cartStore.cartItems.forEach((localItem) => {
      const remoteItem = remoteItemsMap.get(localItem.id);

      if (remoteItem) {
        const newPrice = parseFloat(remoteItem.price);
        if (!isNaN(newPrice)) {
          localItem.price = newPrice;
        }
      }
    });
  };

  const computeCart = () => {
    syncCartItems(syncCartItemsPrices);
  };

  const getCartToken = () => {
    return cartToken.value;
  };

  const clearCartToken = () => {
    cartToken.value = null;
  };

  return {
    computeCart,
    isProcessing,
    getCartToken,
    clearCartToken,
  };
}
